import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/general')({
  component: () => (
    <Navigate
      from="/workspaces/$workspaceId/bots/$botId/webchat/v2/general"
      to="/workspaces/$workspaceId/bots/$botId/webchat/v2/identity"
    />
  ),
})
